/* eslint-disable no-unused-vars */
import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import routes from '../routes';
import { backgroundColors, themePrimary } from '../material-ui-theme';
import BrandDetails from '../partials/Authentication/BrandDetails';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100vw',
    height: '100vh',
    background: backgroundColors.grey,
    display: 'flex',

    '& .formContainer': {
      paddingTop: 22,
      paddingBottom: 22,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    overflow: 'auto',
    '& > .MuiGrid-root': {
      height: '100%',
    },
  },
  centerContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'initial',
    },
  },
  QuantiplyLoginContainer: {
    order: 1,
    maxWidth: 406,
    display: 'flex',
    alignItems: 'center',
    marginTop: 30,

    [theme.breakpoints.up('md')]: {
      order: 2,
      marginTop: 0,
    },
  },
}));

function QuantiplyLoginContainer({ getRoutes }) {
  const classes = useStyles();

  return (
    <div className={classes.QuantiplyLoginContainer}>
      <Grid container spacing={2}>
        <Suspense fallback={<span />}>
          <Switch>{getRoutes(routes)}</Switch>
        </Suspense>
      </Grid>
    </div>
  );
}

function Special({ getRoutes }) {
  const classes = useStyles();

  return (
    <div className="authenticate">
      <ThemeProvider theme={themePrimary}>
        <div className={classes.root}>
          <main className={classes.content}>
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.centerContainer}>
                <QuantiplyLoginContainer getRoutes={getRoutes} />
              </Grid>
            </Grid>
          </main>
        </div>
      </ThemeProvider>
    </div>
  );
}

class SpecialLayout extends React.Component {
  constructor(props) {
    super(props);
  }

  getRoutes = () => {
    return routes.map((props) => (
      <Route
        key={props.id}
        path={props.path}
        render={(p) => <props.component {...p} />}
        exact={props.exact}
        strict={props.strict}
      />
    ));
  };

  render() {
    return <Special getRoutes={this.getRoutes} {...this.props} />;
  }
}

SpecialLayout.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default SpecialLayout;
